module.exports = __webpack_public_path__ + "media/images/athletes/3704-5c4615ba60478f97087d43fa7579ec48.png";